import Tastet from '../tastet.js';

// Custom dropdown replacing a native <select> so the list always opens below the trigger.
// Markup: .select > .select--trigger (button) + ul.select--list > li.select--option + input[hidden].
export default class Select extends Tastet.View {
  init() {
    var root = this.$element.get(0);
    if (!root) return;

    this.root = root;
    this.triggerEl = root.querySelector('.select--trigger');
    this.valueEl = root.querySelector('.select--value');
    this.list = root.querySelector('.select--list');
    this.input = root.querySelector('input[type="hidden"]');
    this.options = Array.prototype.slice.call(root.querySelectorAll('.select--option'));
  }

  addEvents() {
    if (!this.triggerEl || !this.list) return;

    // View init strips the markup's `hidden` attribute from our subtree, so the
    // list would render expanded until the first click anywhere on the page.
    // Re-assert the closed state now that init is done.
    this.close();

    this.triggerEl.addEventListener('click', this.onTriggerClick.bind(this));
    this.options.forEach(opt => {
      opt.addEventListener('click', () => this.choose(opt));
    });
    document.addEventListener('click', this.onOutsideClick.bind(this));
    this.root.addEventListener('keydown', this.onKeydown.bind(this));
  }

  isOpen() {
    return this.triggerEl.getAttribute('aria-expanded') === 'true';
  }

  open() {
    this.list.hidden = false;
    this.triggerEl.setAttribute('aria-expanded', 'true');
    var selected = this.list.querySelector('.is-selected') || this.options[0];
    selected && selected.focus();
  }

  close() {
    this.list.hidden = true;
    this.triggerEl.setAttribute('aria-expanded', 'false');
  }

  choose(opt) {
    this.options.forEach(o => {
      o.classList.remove('is-selected');
      o.setAttribute('aria-selected', 'false');
    });
    opt.classList.add('is-selected');
    opt.setAttribute('aria-selected', 'true');
    this.valueEl.textContent = opt.textContent;
    if (this.input) this.input.value = opt.getAttribute('data-value');
    this.close();
    this.triggerEl.focus();
  }

  // events ----------------------------------------------------------------------------------------------------------
  onTriggerClick() {
    this.isOpen() ? this.close() : this.open();
  }

  onOutsideClick(e) {
    if (this.root.contains(e.target)) return;
    this.close();
  }

  onKeydown(e) {
    if (e.key === 'Escape') {
      this.close();
      this.triggerEl.focus();
      return;
    }

    var current = this.options.indexOf(document.activeElement);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (!this.isOpen()) return this.open();
      (this.options[current + 1] || this.options[0]).focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      (this.options[current - 1] || this.options[this.options.length - 1]).focus();
    } else if ((e.key === 'Enter' || e.key === ' ') && current > -1) {
      e.preventDefault();
      this.choose(this.options[current]);
    }
  }
}
